/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class CustomerContactListVO extends JSONable {

  uuid: string | undefined = undefined;
  contactName: string | undefined = undefined;
  contactCountry: string | undefined = undefined;
  email: string | undefined = undefined;
  phoneNumber: string | undefined = undefined;
  jobTitleValue: string | undefined = undefined;
  neverCall: boolean | undefined = undefined;
  buyingRoleValue: string | undefined = undefined;
  contactTypeValue: string | undefined = undefined;
  visibilityType: string | undefined = undefined;
  contactMethod: string | undefined = undefined;
  receivesRequests: boolean | undefined = undefined;
  customerContactUuid: string | undefined = undefined;

}
